import formatCurrency from "format-currency";
import { isEmpty, isFinite, isNil } from "lodash-es";
import Vue from "vue";

export default ({ app }) => {
  const filters = {
    valueFilter(value) {
      if (isNil(value)) return "-";
      return value;
    },

    dateFilterShort(value) {
      if (isEmpty(value)) return "-";
      return app.$dateFunc({ input: value }).format("DD/MMM/YYYY");
    },

    currencyFilter(val) {
      if (val === null) return "-";
      return formatCurrency(val, {
        symbol: "IDR ",
        format: "%s%v",
        locale: "id",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },

    currencyFilterRp(val) {
      if (val === null) return "-";
      return formatCurrency(val, {
        symbol: "Rp ",
        format: "%s%v",
        locale: "id",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      });
    },

    priceFilter(val) {
      let result = "";
      if (val) {
        result = formatCurrency(val, {
          locale: "id",
        });
      } else {
        result = "-";
      }

      // split price with comma
      const [price] = result.split(",");
      return price;
    },

    percentageFilter(val) {
      return `${Math.round(val * 10000) / 100} %`;
    },

    MBToBytesFilter(number) {
      if (!isFinite(number)) {
        return "-";
      }
      return number * (1024 * 1024);
    },
    KBToBytesFilter(number) {
      if (!isFinite(number)) {
        return "-";
      }
      return number * 1024;
    },
    bytesToKBFilter(number) {
      if (!isFinite(number)) {
        return "-";
      }
      return number / 1024;
    },
    MBToKBFilter(number) {
      if (!isFinite(number)) {
        return "-";
      }
      return number * 1024;
    },
    bytesToMBFilter(number) {
      if (!isFinite(number)) {
        return "-";
      }
      return number / (1024 * 1024);
    },
    KBToMBFilter(number) {
      if (!isFinite(number)) {
        return "-";
      }
      return number / 1024;
    },
    // https://stackoverflow.com/a/37040444/9433691
    extensionWording(string) {
      const stringTemp =
        string !== null && typeof string !== "undefined" ? string : "";
      let afterDot = stringTemp.substr(stringTemp.indexOf(".") + 1);

      if (afterDot === "xlsx") {
        afterDot = "xls";
      }

      if (afterDot === "jpeg") {
        afterDot = "jpg";
      }

      return afterDot;
    },
    lastSeen(dateInput) {
      if (dateInput) {
        return app.$dateFunc({ input: dateInput }).fromNow();
      }
      return "Never login";
    },
  };

  Object.keys(filters).forEach((v) => {
    Vue.filter(v, filters[v]);
  });
};
